import * as React from 'react';
import getScenarioStore from '../../selectors/getScenarioStore';
import SearchSuggestion from './SearchSuggestion';
import { CategorySearchSuggestion as CategorySuggestion } from 'owa-search-service';
import { observer } from 'mobx-react-lite';
import { SearchScenarioId } from '../../store/schema/SearchScenarioId';
import { SMALL_SUGGESTION_HEIGHT } from '../../searchConstants';
import { CategoryIcon, getMasterCategoryList } from 'owa-categories';

const searchSuggestionStyles = require('./SearchSuggestion.scss');
const styles = require('./CategorySearchSuggestion.scss');

export interface CategorySearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: CategorySuggestion;
    suggestionSetTraceId: string;
}

const CategorySearchSuggestion = observer(function CategorySearchSuggestion(
    props: CategorySearchSuggestionProps
) {
    const { index, scenarioId, suggestion, suggestionSetTraceId } = props;

    const categoryName = suggestion.Name;
    const searchText = getScenarioStore(scenarioId).searchTextForSuggestion;

    let matchText = '';
    let nonMatchText = categoryName;

    if (categoryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) == 0) {
        matchText = categoryName.substr(0, searchText.length);
        nonMatchText = categoryName.substr(searchText.length, categoryName.length - 1);
    }

    const style: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT}px`,
    };

    return (
        <SearchSuggestion
            ariaLabel={categoryName}
            content={
                <div className={styles.container} style={style}>
                    <CategoryIcon
                        categoryName={categoryName}
                        iconClassName={styles.icon}
                        categoryList={getMasterCategoryList()}
                    />
                    <span className={searchSuggestionStyles.keywordMatchSuggestion}>
                        {matchText}
                    </span>
                    <span className={searchSuggestionStyles.keywordNonMatchSuggestion}>
                        {nonMatchText}
                    </span>
                </div>
            }
            suggestion={suggestion}
            suggestionSetTraceId={suggestionSetTraceId}
            scenarioId={scenarioId}
            index={index}
        />
    );
});
export default CategorySearchSuggestion;
